<template>
  <b-modal
    :id="id"
    :ref="id"
    v-model="internalVisible"
    hide-footer
    hide-header
    hide-header-close
    centered
    :size="size"
    :no-close-on-backdrop="noCloseOnBackdrop"
    :no-close-on-esc="noCloseOnEsc"
    content-class="rounded-[20px] border-0 overflow-hidden shadow-2xl"
    body-class="p-0"
    @show="$emit('show')"
    @shown="$emit('shown')"
    @hide="$emit('hide')"
    @hidden="$emit('hidden')"
  >
    <div class="p-6 md:p-7 bg-white text-center">
      <!-- Error Icon -->
      <slot name="icon">
        <div class="flex justify-center mb-4">
          <img
            src="https://storage.googleapis.com/komerce/assets/svg/Icon-Error.svg"
            alt="Verifikasi Terblokir"
            class="w-16 h-16"
          >
        </div>
      </slot>

      <!-- Modal Title -->
      <slot name="title">
        <h3 class="text-xl md:text-2xl font-bold text-[#111827] mb-2 leading-tight">
          {{ title }}
        </h3>
      </slot>

      <!-- Modal Description -->
      <slot name="description">
        <p class="text-sm md:text-[14px] text-[#6B7280] max-w-[340px] mx-auto leading-relaxed mb-6">
          {{ description }}
        </p>
      </slot>

      <!-- Actions -->
      <slot
        name="actions"
        :close="handleUnderstood"
        :understood="handleUnderstood"
        :contact-cs="handleContactCS"
      >
        <div class="flex flex-col gap-2.5">
          <button
            type="button"
            class="w-full py-2.5 px-4 rounded-xl bg-[#F95F17] hover:bg-[#E05310] text-white font-semibold text-sm focus:outline-none transition-colors duration-150 cursor-pointer shadow-sm active:transform active:scale-[0.99]"
            @click="handleUnderstood"
          >
            {{ closeButtonText }}
          </button>
          <button
            v-if="showCsButton"
            type="button"
            class="w-full py-2.5 px-4 rounded-xl border border-[#D1D5DB] bg-white hover:bg-gray-50 text-[#374151] font-semibold text-sm focus:outline-none transition-colors duration-150 cursor-pointer"
            @click="handleContactCS"
          >
            {{ csButtonText }}
          </button>
        </div>
      </slot>
    </div>
  </b-modal>
</template>

<script>
import { removeLocalStorageLogout } from '@/auth/utils'

export default {
  name: 'ModalVerifikasiTerblokir',
  props: {
    id: {
      type: String,
      default: 'modal-verifikasi-terblokir',
    },
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Verifikasi Terblokir',
    },
    description: {
      type: String,
      default: 'Kamu telah salah memasukkan kode OTP sebanyak 3 kali. Demi keamanan akunmu, proses verifikasi diblokir sementara selama 24 jam.',
    },
    csButtonText: {
      type: String,
      default: 'Hubungi CS',
    },
    closeButtonText: {
      type: String,
      default: 'Mengerti',
    },
    showCsButton: {
      type: Boolean,
      default: false,
    },
    autoLogout: {
      type: Boolean,
      default: true,
    },
    csUrl: {
      type: String,
      default: 'https://api.whatsapp.com/send?phone=6281328014084&text=Halo%20Admin%2C%20akun%20saya%20terblokir%20karena%20salah%20input%20OTP',
    },
    noCloseOnBackdrop: {
      type: Boolean,
      default: true,
    },
    noCloseOnEsc: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: 'md',
    },
  },
  data() {
    return {
      internalVisible: this.value,
    }
  },
  watch: {
    value(newVal) {
      this.internalVisible = newVal
    },
    internalVisible(newVal) {
      this.$emit('input', newVal)
    },
  },
  methods: {
    show() {
      this.internalVisible = true
      if (this.$bvModal) {
        this.$bvModal.show(this.id)
      }
    },
    hide() {
      this.internalVisible = false
      if (this.$bvModal) {
        this.$bvModal.hide(this.id)
      }
    },
    handleUnderstood() {
      this.$emit('understood')
      this.hide()
      if (this.autoLogout) {
        removeLocalStorageLogout()
        window.location.replace('/login')
      }
    },
    handleContactCS() {
      this.$emit('contact-cs')
      if (this.csUrl) {
        window.open(this.csUrl, '_blank')
      }
    },
  },
}
</script>
